export default __webpack_public_path__ + "static/media/avatar.07300db7.png";